import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Grid, Environment, ContactShadows } from '@react-three/drei';
import Avatar from './Avatar';

const Biomechanics3DView = ({ landmarks, role, width = '100%', height = '100%' }) => {
    return (
        <div style={{ width, height }} className="bg-gray-900 border-l border-gray-700">
            <Canvas camera={{ position: [0, 1.5, 4], fov: 45 }} shadows>
                <ambientLight intensity={0.8} />
                <pointLight position={[10, 10, 10]} intensity={1} castShadow />

                <Suspense fallback={null}>
                    <Avatar landmarks={landmarks} role={role} />
                    <Grid
                        position={[0, -0.01, 0]}
                        args={[10, 10]}
                        cellSize={0.5}
                        cellThickness={0.5}
                        cellColor="#6f6f6f"
                        sectionSize={3}
                        sectionThickness={1}
                        sectionColor="#9d4b4b"
                        fadeDistance={30}
                        fadeStrength={1}
                        followCamera={false}
                        infiniteGrid={true}
                    />
                    {/* <Environment preset="city" /> */}
                </Suspense>

                {!role && <ContactShadows opacity={0.5} scale={10} blur={1} far={10} resolution={256} color="#000000" />}
                <OrbitControls makeDefault minPolarAngle={0} maxPolarAngle={Math.PI / 1.8} target={[0, 0.8, 0]} />
            </Canvas>

            <div className="absolute bottom-4 right-4 bg-black/50 p-2 rounded text-xs text-gray-400 pointer-events-none">
                Drag to Rotate • Scroll to Zoom
            </div>
        </div>
    );
};

export default Biomechanics3DView;
